module.exports = __webpack_public_path__ + "img/kaftar-transparent.dc612bfc.png";